import { Tooltip } from '@base-ui/react/tooltip'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface TooltipPositionerProps extends PartProps<Tooltip.Positioner.Props> {
  className?: string
}

/** Above every other layer, including dialogs and popups that sit at z-1000 in the app. */
function TooltipPositioner({ className, side = 'top', sideOffset = 8, ...props }: TooltipPositionerProps) {
  return (
    <Tooltip.Positioner
      className={twMerge('isolate z-[9999]', className)}
      side={side}
      sideOffset={sideOffset}
      {...props}
    />
  )
}

export { TooltipPositioner }
